import React from 'react';
import { useCamera } from '../hooks';

/**
 * Camera Component using Cordova native camera
 * Allows capturing photos using device camera with proper permissions
 */
const CameraComponent = ({ onCapture }) => {
  const {
    takePhoto,
    selectFromGallery,
    photo,
    loading,
    error,
    clearPhoto,
    clearError
  } = useCamera();

  const handleTakePhoto = async () => {
    try {
      const photoData = await takePhoto({
        quality: 80,
        targetWidth: 1024,
        targetHeight: 1024,
        correctOrientation: true,
        saveToPhotoAlbum: false
      });
      
      if (onCapture) {
        onCapture(photoData);
      }
    } catch (err) {
      console.error('Failed to take photo:', err);
    }
  };

  const handleSelectFromGallery = async () => {
    try {
      const photoData = await selectFromGallery({
        quality: 90,
        targetWidth: 1024,
        targetHeight: 1024,
        correctOrientation: true
      });
      
      if (onCapture) {
        onCapture(photoData);
      }
    } catch (err) {
      console.error('Failed to select photo:', err);
    }
  };

  return (
    <div className="camera-component">
      <div className="camera-container">
        {error && (
          <div className="alert alert-danger" role="alert">
            <strong>Error:</strong> {error}
            <button 
              type="button" 
              className="btn-close float-end" 
              onClick={clearError}
              aria-label="Close"
            ></button>
          </div>
        )}

        {photo ? (
          <div className="captured-image">
            <img src={photo} alt="Captured" style={{ maxWidth: '100%' }} />
            <div className="camera-actions mt-3">
              <button
                className="btn btn-primary me-2"
                onClick={() => {
                  clearPhoto();
                  if (onCapture) {
                    onCapture(null);
                  }
                }}
              >
                Retake
              </button>
              <button
                className="btn btn-success"
                onClick={() => {
                  // Handle save image
                  console.log('Image saved');
                  if (onCapture) {
                    onCapture(photo);
                  }
                }}
              >
                Save
              </button>
            </div>
          </div>
        ) : (
          <div className="camera-controls">
            <button
              className="btn btn-primary btn-lg me-2"
              onClick={handleTakePhoto}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Taking Photo...
                </>
              ) : (
                '📷 Take Photo'
              )}
            </button>
            <button
              className="btn btn-secondary btn-lg"
              onClick={handleSelectFromGallery}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Selecting...
                </>
              ) : (
                '🖼️ Select from Gallery'
              )}
            </button>
          </div>
        )}
        
        {!photo && !error && !loading && (
          <div className="alert alert-info mt-3" role="alert">
            Click the button above to take a photo with your device camera.
          </div>
        )}
      </div>
    </div>
  );
};

export default CameraComponent;
